const locale = {
  SOMETHING_WENT_WRONG: 'Algo salió mal. Tuvimos un inconveniente. Por favor, intenta de nuevo.',
  SOMETHING_WENT_WRONG_PLAIN: 'Algo salió mal',
  ERROR: '¡Oh no!',
};

export default locale;
